import { render, staticRenderFns } from "./StudentVideoAnswerRecords.vue?vue&type=template&id=016d1700&scoped=true"
import script from "./StudentVideoAnswerRecords.vue?vue&type=script&lang=js"
export * from "./StudentVideoAnswerRecords.vue?vue&type=script&lang=js"
import style0 from "./StudentVideoAnswerRecords.vue?vue&type=style&index=0&id=016d1700&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016d1700",
  null
  
)

export default component.exports